export default __webpack_public_path__ + "static/media/Pilz-Layer-1-new.34e89657.png";